import type { ControlPanelTranslations } from "../en/ControlPanel";
import type { TranslationShape } from "../../store/types";

export const controlPanelEs: TranslationShape<ControlPanelTranslations> = {
  pageTitle: "Panel de Control",
  pageSubtitle: "Sistema de gestión de categorías con IA para optimizar surtidos y planogramas",

  workflow: {
    title: "Proceso de Trabajo",
    subtitle: "Tu flujo paso a paso de gestión de categorías",
    step: "PASO {{number}}",
    majorReview: "REVISIÓN MAYOR",
    majorReviewDesc: "Optimización completa de surtido",
    minorReview: "REVISIÓN MENOR",
    minorReviewDesc: "Validación rápida de planogramas",
  },

  steps: {
    performanceAnalysis: "Análisis de Desempeño",
    performanceAnalysisDesc:
      "Analiza el rendimiento de categorías, identifica acciones y genera simulaciones",
    assortmentSimulation: "Simulación de Surtido",
    assortmentSimulationDesc:
      "Edita y optimiza simulaciones para revisión mayor y menor, y genera planogramas",
    spacePlanning: "Planogramación",
    spacePlanningDesc: "Valida arreglos de planogramas y edita diseños según sea necesario",
    minorReviewTitle: "Revisión Menor",
    minorReviewDesc:
      "Revisa alertas de planogramas y valida el cumplimiento del surtido (Revisión Menor)",
  },

  objects: {
    title: "Resumen de Objetos",
    subtitle: "Inventario actual de los objetos de tu sistema",
    loadFailedTitle: "No se pudieron cargar los totales",
    loadFailedMessage: "Actualiza la página para intentarlo de nuevo.",
    stores: "Tiendas",
    storesDesc: "Ubicaciones de tiendas y agrupaciones por cluster",
    clusters: "Clusters",
    planograms: "Planogramas",
    planogramsDesc: "Planogramas y definiciones de surtido",
    assortments: "Surtidos",
    categories: "Categorías",
    categoriesDesc: "Catálogo de productos y jerarquías de categorías",
    products: "Productos",
    productsDesc: "Catálogo de productos y gestión de SKUs",
    fixtures: "Muebles",
    fixturesDesc: "Definiciones y configuraciones de muebles de tienda",
    decisionTrees: "Flujos de Mercadeo",
    decisionTreesDesc: "Árboles de decisión de categoría para distribución de planogramas",
    trees: "Árboles",
    active: "Activos",
  },

  alerts: {
    title: "Alertas de Planogramas",
    subtitle: "Advertencias en planogramas activos que requieren atención",
    critical: "Crítico",
    medium: "Medio",
    low: "Bajo",
    category: "Categoría: {{category}}",
    outOfStockTitle: "Productos agotados en planogramas",
    outOfStockDesc:
      "15 planogramas de Salsas tienen SKUs sin inventario (VALENTINA Picante, BÚFALO Chipotle, CHOLULA Original)",
    underperformingTitle: "Planogramas con bajo rendimiento",
    underperformingDesc:
      "8 planogramas de Salsas tienen ventas -18% por debajo del promedio del cluster en las últimas 4 semanas",
    underutilizedTitle: "Espacio en estante subutilizado",
    underutilizedDesc:
      "12 planogramas de Salsas tienen 22% de espacio vacío - oportunidad de expandir SKUs top",
    complianceTitle: "Falla de cumplimiento de surtido",
    complianceDesc:
      "6 planogramas sin HERDEZ Tradicional y TABASCO Original según surtido obligatorio",
    atRiskTitle: "Categoría en riesgo",
    atRiskDesc: "Esta categoría tiene un puntaje de salud bajo y requiere atención inmediata",
    watchTitle: "Categoría en observación",
    watchDesc: "Esta categoría muestra un rendimiento en declive y debe ser monitoreada",
    storeContext: "{{storeCount}} tiendas afectadas ({{stores}})",
    storeContextAll: "{{storeCount}} tiendas afectadas",
    deadStockTitle: "Stock muerto detectado",
    missingTopProductsTitle: "Productos top faltantes en tiendas",
    lowPerformanceTitle: "Tiendas con bajo desempeño en la categoría",
    affectedStoresHeading: "Tiendas afectadas ({{count}})",
    missingProductsHeading: "Productos faltantes ({{count}})",
    noData: "No hay alertas disponibles",
    loadErrorTitle: "Error al cargar alertas",
    loadError: "No se pudieron cargar las alertas desde la API",
  },
};
